import ApiService from '@/api/http/ApiService';
import axios, { AxiosPromise } from 'axios';
import { Payment } from '@/interfaces/models/Payment';

export default class ArcavisApiService extends ApiService<any> {
  constructor() {
    super('arcavis');
  }

  public refund(data: { order: string }): AxiosPromise<Payment> {
    return axios.post(`${this.getBaseUrl()}/orders/refund`, {
      orderId: data.order,
    });
  }
}
